import React from 'react';
import i18n from 'i18next';
import Authenticated from '@/Layouts/Authenticated';
import ValidationErrors from '@/Components/ValidationErrors';
import {Head, Link, useForm, usePage} from '@inertiajs/inertia-react';
import {FormInput} from "@/Components/Controls";
import ProductLogo from "@/Components/ProductLogo";
import AbstractSignupArtwork from "@/Components/AbstractSignupArtwork";

export default function VerifyEmail() {
    const email = usePage().props.obfuscatedEmail;

    const {data, setData, post, processing, errors, reset} = useForm({
        code: '',
        type: usePage().props.type
    });

    const onChange = (name, value) => {
        setData(name, value);
    };

    const submit = (e) => {
        e.preventDefault();

        post(route('verification.verify-by-code'));
    };

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            <AbstractSignupArtwork/>
            <Head title="Verify Email"/>
            <div className="verify-email">
                <form onSubmit={submit}>
                    <ProductLogo />
                    {false && <ValidationErrors errors={errors}/>}
                    <div className="instructions">{i18n.t("verify-email.weve-sent")} {email}</div>
                    <div className="row">
                        <FormInput
                            error={errors["code"]}
                            format="text"
                            name="code"
                            isFocused={true}
                            autoComplete="one-time-code"
                            value={data.code}
                            onChange={onChange}
                            label={i18n.t("verify-email.login-code")}
                            className="col-12"
                            dataTestid="verify_email-form_input-login_code"
                        />
                    </div>
                    <button data-testid="verify_email-form_submit_button" className="w-100 btn btn-primary" type="submit">
                        {i18n.t("verify-email.submit")}
                    </button>
                    <div className="verify-email-options">
                        <Link
                            method="POST"
                            href={route('verification.email.send')}
                            className="link"
                            data-testid="verify_email-link-resend_code"
                        >
                            {i18n.t("verify-email.resend-code")}
                        </Link>
                        or
                        <Link
                            href={route('logout')}
                            className="link"
                            data-testid="verify_email-link-back_to_login"
                        >
                            {i18n.t("verify-email.back-to-login")}
                        </Link>
                    </div>
                </form>
            </div>
        </Authenticated>
    );
}

